const data = {
	"width": 512,
	"height": 512,
	"body": "<path fill=\"currentColor\" d=\"m224 96l16-32l32-16l-32-16l-16-32l-16 32l-32 16l32 16l16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0L53.34 53.33L0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37c8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91l86.6-86.6l50.91 50.91l-86.6 86.6z\"/>"
};
exports.__esModule = true;
exports.default = data;
